document.addEventListener("DOMContentLoaded", () => {

  function updateColorTitle() {
    const span = document.querySelector('.dynamic-option-value[data-option-index="1"]');
    if (!span) return;

    // Match any input name that starts with "Color-1" (trailing space handled)
    const selectedInput = document.querySelector('input[name^="Color-1"]:checked');

    if (selectedInput) {
      span.textContent = selectedInput.value;
    }
  }

  // Update on page load
  updateColorTitle();

  // Update whenever the user changes a variant
  document.addEventListener("change", updateColorTitle);
});
